import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Home } from "Shared/appIcons";
import { UnauthenticatedLayout } from "Shared/Layouts/UnauthenticatedLayout";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";
import type { FallbackProps } from "react-error-boundary";
import { Button } from "@/components/ui/button";

export const ApplicationErrorPage = (props: FallbackProps) => {
	const error = props.error as { name?: string; message?: string } | undefined;
	const { t } = useResource();

	return (
		<UnauthenticatedLayout title={t(Resources.Errors.ApplicationError.Title)}>
			<div className="max-w-2xl space-y-4 text-center">
				<h1 className="text-2xl font-bold">
					{t(Resources.Errors.ApplicationError.Heading)}
				</h1>
				<p>{t(Resources.Errors.ApplicationError.Description)}</p>

				<UnstyledLink to="/">
					<Button size="lg">
						<Home className="mr-2 h-4 w-4" />
						{t(Resources.Errors.ApplicationError.Home)}
					</Button>
				</UnstyledLink>

				<p className="mt-6 text-label">
					{t(Resources.Errors.ApplicationError.DevHint)}
				</p>
				<pre className="bg-muted overflow-auto rounded-md p-3 text-left text-caption">
					<code>{JSON.stringify(error?.name)}</code>
				</pre>
				<pre className="bg-muted overflow-auto rounded-md p-3 text-left text-caption">
					<code>{JSON.stringify(error?.message)}</code>
				</pre>
			</div>
		</UnauthenticatedLayout>
	);
};
